import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

export type OptOutText =
    | 'STOP_TO_QUIT'
    | 'STOP_TO_UNSUBSCRIBE'
    | 'STOPALL_TO_QUIT'
    | 'REPLY_STOP_TO_UNSUBSCRIBE'
    | 'UNSUBSCRIBE_TO_QUIT';

export type OptOutOption = {
    value: OptOutText | null;
    label: string;
};

// Values should match the ones in GraphQL/Type/Enum/OptOutType.php
// Labels should match the consts in application/models/Sms/Edition.php
const REQUIRED_OPT_OUT_OPTIONS: OptOutOption[] = [
    {
        value: 'STOP_TO_QUIT',
        label: 'STOP to quit',
    },
    {
        value: 'STOP_TO_UNSUBSCRIBE',
        label: 'STOP to unsubscribe',
    },
    {
        value: 'STOPALL_TO_QUIT',
        label: 'STOPALL to quit',
    },
    {
        value: 'REPLY_STOP_TO_UNSUBSCRIBE',
        label: 'Reply STOP to unsubscribe',
    },
    {
        value: 'UNSUBSCRIBE_TO_QUIT',
        label: 'UNSUBSCRIBE to quit',
    },
];

const NOT_REQUIRED_OPT_OUT_OPTIONS: OptOutOption[] = [
    {
        value: null,
        label: '-- None --',
    },
    ...REQUIRED_OPT_OUT_OPTIONS,
];

type Props = {
    isRequired: boolean;
    isDisabled?: boolean;
    selectedOptOutText: string | null | undefined;
    onOptOutTextChange: (optOut: OptOutOption) => void;
};

export function OptOutTextSelect(props: Props) {
    const optOutOptionsToUse = props.isRequired
        ? REQUIRED_OPT_OUT_OPTIONS
        : NOT_REQUIRED_OPT_OUT_OPTIONS;

    const selectedOptOutOption = optOutOptionsToUse.find((optOut) => {
        if (props.selectedOptOutText === null) {
            return props.selectedOptOutText === optOut.value;
        } else {
            return optOut.label === props.selectedOptOutText;
        }
    });

    return (
        <FormField
            innerId='optOutText'
            label='Opt-out text'
            isRequired={props.isRequired}
            noMargin={true}
        >
            <SelectPickerGeneric
                options={optOutOptionsToUse}
                value={selectedOptOutOption}
                onChange={(option: OptOutOption) => props.onOptOutTextChange(option)}
                placeholder='-- None --'
                isDisabled={props.isDisabled}
                menuPlacement='auto'
            />
        </FormField>
    );
}
